var _path, _line, _line2, _polyline, _line3, _line4, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorToilets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.64,26.381v-9.986c0-1.524-1.235-2.759-2.759-2.759h-7.292c-1.524,0-2.759,1.235-2.759,2.759v9.986"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.694,
    y1: 39.193,
    x2: 8.694,
    y2: 18.249
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.802,
    y1: 18.249,
    x2: 13.802,
    y2: 39.193
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "22.492 27.741 26.402 13.636 33.26 13.636 37.171 27.741"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27.992,
    y1: 38.61,
    x2: 26.536,
    y2: 25.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.126,
    y1: 25.39,
    x2: 31.67,
    y2: 38.61
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.235,
    cy: 6.301,
    r: 3.494
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.831,
    cy: 6.301,
    r: 3.494
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorToilets);
export default __webpack_public_path__ + "static/media/indoor-toilets.0b707d23ee31571f4e5ef0c4f3e8a649.svg";
export { ForwardRef as ReactComponent };